import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import jwtCookieManager from './jwtCookieManager';
import './SupportPortalPage.css';

export default function SupportPortalPage() {
  // Authentication token
  const token = jwtCookieManager.getToken();
  // Component state
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [newTicket, setNewTicket] = useState({ subject: '', message: '' });

  // Load tickets from API
  const fetchTickets = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/tickets`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to load tickets');
      setTickets(data.tickets || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch tickets on mount when token is available
  useEffect(() => {
    if (token) fetchTickets();
  }, [token]);

  // Redirect to login if not authenticated
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  const handleNewTicket = async (e) => {
    e.preventDefault();
    setError('');
    const { subject, message } = newTicket;
    if (!subject.trim() || !message.trim()) {
      setError('Subject and message are required');
      return;
    }
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/tickets`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ subject, message })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to create ticket');
      setNewTicket({ subject: '', message: '' });
      fetchTickets();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="support-portal-container">
      <h2>Your Support Tickets</h2>
      {error && <p className="error">{error}</p>}
      <div className="ticket-list">
        {loading ? (
          <p>Loading tickets&hellip;</p>
        ) : tickets.length > 0 ? (
          tickets.map(ticket => (
            <div key={ticket.id} className="ticket-item">
              <div className="ticket-header">
                <span className="ticket-subject">{ticket.subject}</span>
                <span className={`ticket-status status-${ticket.status.toLowerCase()}`}>{ticket.status}</span>
              </div>
              <div className="ticket-meta">Created {new Date(ticket.createdAt).toLocaleString()}</div>
              <div className="ticket-body">{ticket.message}</div>
            </div>
          ))
        ) : (
          <p>No tickets found. Create one below.</p>
        )}
      </div>
      <div className="new-ticket-form">
        <h3>Create New Ticket</h3>
        <form onSubmit={handleNewTicket} className="ticket-form">
          <input
            className="input-field"
            type="text"
            placeholder="Subject"
            value={newTicket.subject}
            onChange={e => setNewTicket({ ...newTicket, subject: e.target.value })}
            required
          />
          <textarea
            className="input-field"
            rows={4}
            placeholder="Describe your issue"
            value={newTicket.message}
            onChange={e => setNewTicket({ ...newTicket, message: e.target.value })}
            required
          />
          <button type="submit" className="btn-primary">Submit Ticket</button>
        </form>
      </div>
    </div>
  );
}